import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowLeft14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M3.81065 7.75002L7.03032 10.9697L5.96966 12.0304L0.939331 7.00002L5.96966 1.9697L7.03032 3.03036L3.81066 6.25002L13 6.25002V7.75002L3.81065 7.75002Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowLeft14.displayName = 'ArrowLeft14';
export default ArrowLeft14;
